import React, { PropsWithChildren } from 'react';

import { useCurrentUser } from '~/src/common/user';
import { isSSR } from '~/src/common/utilities';
import { useHasMounted } from '~/src/components/hooks';

export const StartFreeTrialCTAContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useCurrentUser();

  const { hasMounted } = useHasMounted();
  const isFirstRender = !hasMounted;
  if (isSSR() || isFirstRender || isLoggedIn) {
    return null;
  }

  return <>{children}</>;
};
